<template>
  <div>
    <h6 class="titulo-inaplicabilidade" v-if="imposto">Inaplicabilidade da {{imposto}}</h6>
    <span class="inaplicabilidade" v-html="textoNegrito" />
  </div>
</template>

<script>
import stringFormatMixin from '@/mixins/stringFormatMixin'

export default {
  name: 'Inaplicabilidade',
  props: {
    imposto: String,
    texto: String
  },
  mixins: [stringFormatMixin],

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  computed: {
    textoNegrito() {
      return this.strReplace(this.texto, '<label class="titulo">Inaplicabilidade da substituição tributária:</label></br></br>', '<h6 style="font-weight: 600;">Inaplicabilidade da substituição tributária:</h6>')
    }
  },

  methods: {
    
  },
};
</script>

<style lang="css" scoped>
/* * {
  font-weight: 600;
} */
.inaplicabilidade >>> .titulo {
  font-size: 1rem;
}
.titulo-inaplicabilidade {
  font-weight: 600;
}
</style>